export default __webpack_public_path__ + "static/media/img (1).bc409d4d.jpg";